import React, { useState } from 'react';
import '../index.scss';
import '../home.scss';
import tight1664logo from '../assets/logo/tight1664logo.png';
import supabase from '../helper/supabaseClient';
import { Link } from 'react-router-dom';


function PasswordReset() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (event) => {
  event.preventDefault();
  setMessage("");

  const { error } = await supabase.auth
  .resetPasswordForEmail(email, {redirectTo: "https://portal.1664trainingsolutions.co.uk/resetPassword"})

  if (error) {
    setError("Email not found. Please register a new account");
    setEmail("");
    setMessage("");
  } else {
    setMessage("If your email exists in our system, you will receive a password reset link shortly. Please check your email (including your junk inbox!).");
    setEmail("")
    setError("");
  };
  }

  return (
    <div className="homepage">
     
      <div className="grid-left">
      <img src={tight1664logo} alt="1664 Logo" />
      <h1 style={{fontSize: "2rem"}}>WELCOME TO THE <br></br>1664 PRACTITIONER PORTAL</h1>
      </div>

      <div className="grid-right">
        <h2 style={{fontSize: "1.6rem"}}>REQUEST PASSWORD RESET</h2>
        <p>Forgotten your password?</p>
        <p>No problem; please enter your email address below and follow the instructions.</p>

        <form className="reset"> 
          <input
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            type="email"
            placeholder="Email"
            required/>
          <br></br>

          <button type="submit" onClick={handleSubmit}>Reset Password</button>
        </form>
        <br></br>
        {message && <p className="success">{message}</p>}
        {error && <p className="error-message">{error}</p>}
        <p>Remembered your password? <Link to="/">Click here to login.</Link></p>
      </div>
    </div>
  )
}

export default PasswordReset